export default "__VITE_PUBLIC_ASSET__88c683c8__"